const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;
const MILLISECONDS_IN_WEEK = MILLISECONDS_IN_DAY * 7;
const CURRENT_YEAR = new Date().getFullYear();
// The start date to iterate from - when counting weeks, it will be from the last Saturday of the previous year
// e.g. if the start year is 2025, Week 1 will start from the last saturday in Dec 2024
export const START_DATE = new Date(2024, 0, 1).toISOString();
export const END_DATE = new Date().toISOString();

const START_YEAR = new Date(START_DATE).getFullYear();
const YEARS = [CURRENT_YEAR];
export const QUARTERS = ["First Quarter", "Second Quarter", "Third Quarter", "Fourth Quarter"];
export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const YEAR_OPTIONS = [0];
// create array [0, 1, 2, ... , 11]
const MONTH_OPTIONS = Array.from({ length: 12 }, (_, i) => i);
// create array [0, 1, 2, ... , 51]
const WEEK_OPTIONS = Array.from({ length: 52 }, (_, i) => i);
// create array [0, 1, 2, 3]
const QUARTER_OPTIONS = Array.from({ length: 4 }, (_, i) => i);

export enum TimePeriodType {
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  QUARTERLY = "quarterly",
  YEARLY = "yearly",
}

class TimePeriodService {
  private _startDate: Date;
  private _endDate: Date;

  constructor() {
    this._startDate = this.getStartOfWeekOne();
    this._endDate = this.getEndOfYear();
  }

  public get startDate() {
    return this._startDate.toISOString();
  }

  public get endDate() {
    return this._endDate.toISOString();
  }

  // get quarter number, e.g. 1 for Q1, 2 for Q2, etc. from date
  private getQuarterFromDate(date: Date) {
    return Math.floor(date.getMonth() / 3) + 1;
  }

  getStartOfWeekOne() {
    // find the last saturday of the previous year - this is the end of the last week of the previous year
    let weekOne = new Date(START_DATE);
    while (weekOne.getDay() !== 6) {
      // keep walking backwards by one day until you get to the last saturday
      weekOne = new Date(weekOne.getTime() - MILLISECONDS_IN_DAY);
    }
    // get the next day to find the beginning of week one
    return new Date(weekOne.getTime() + MILLISECONDS_IN_DAY);
  }

  getEndOfYear() {
    // Return current date to get data from 2024 until now
    return new Date();
  }

  getPeriodLabel({
    selectedPeriodType,
    periodStart,
    periodEnd,
  }: {
    selectedPeriodType: TimePeriodType;
    periodStart: Date;
    periodEnd: Date;
  }) {
    if (!selectedPeriodType) {
      return "";
    }

    switch (selectedPeriodType) {
      case TimePeriodType.WEEKLY: {
        const lastWeek = new Date().getTime() - MILLISECONDS_IN_WEEK;
        if (periodStart.getTime() < lastWeek && lastWeek < periodEnd.getTime()) {
          return "Last Week";
        }
        const weeksSinceWeekOne =
          Math.floor((periodStart.getTime() - this._startDate.getTime()) / MILLISECONDS_IN_WEEK) +
          1;
        return `Week ${weeksSinceWeekOne} (${periodStart.toLocaleDateString()} - ${periodEnd.toLocaleDateString()})`;
      }
      case TimePeriodType.MONTHLY: {
        return `${MONTHS[periodStart.getMonth()]} ${periodEnd.getFullYear()}`;
      }
      case TimePeriodType.QUARTERLY: {
        return `Q${this.getQuarterFromDate(periodStart)} ${periodEnd.getFullYear()}`;
      }
      case TimePeriodType.YEARLY: {
        return periodEnd.getFullYear();
      }
    }
  }
}

export default new TimePeriodService();
